<nav class="navbar navbar-light bg-light navbar-expand-lg">
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <form class="form-inline my-2 my-lg-0 ms-3 me-2">
            <input id="busquedaFormControl" type="text" class="form-control" [formControl]="busquedaFormControl"
                placeholder="Cliente/Aerovale/Factura/Legajo" (input)="filtrarLegajos()" />
        </form>

        <ul class="navbar-nav me-auto align-items-center">
            <li class="nav-item me-2">
                <select class="form-select" [(ngModel)]="tipoSeleccionado" name="tipo">
                    <option *ngFor="let tipo of tiposBusqueda" [ngValue]="tipo.value">
                        {{ formatLabel(tipo.key) }}
                    </option>
                </select>
            </li>

            <li class="nav-item me-2">
                <div class="input-group">
                    <input type="date" [ngModel]="modelDesde" class="form-control form-control-rounded"
                        (ngModelChange)="modelDesde = $event; onDesdeChange()" name="dt" ngbDatepicker
                        #d="ngbDatepicker" required readonly>
                    <button id="botonDesde" type="button" class="btn btn-secondary" (click)="d.toggle()">
                        <i class="fa fa-calendar" aria-hidden="true"></i>
                    </button>
                </div>
            </li>

            <li class="nav-item me-2">
                <div class="input-group">
                    <input type="date" [ngModel]="modelHasta" class="form-control form-control-rounded"
                        (ngModelChange)="modelHasta = $event" name="dp" [minDate]="minFechaHasta"
                        [maxDate]="maxFechaHasta" ngbDatepicker #h="ngbDatepicker" required readonly>
                    <button id="botonHasta" type="button" class="btn btn-secondary" (click)="h.toggle()">
                        <i class="fa fa-calendar" aria-hidden="true"></i>
                    </button>
                </div>
            </li>

            <li class="nav-item">
                <button class="btn btn-outline-primary my-2 my-lg-0 mx-lg-2" [disabled]="cargandoLista"
                    (click)="buscarDesdeHasta()">
                    <i class="fa fa-search" aria-hidden="true"></i>
                </button>
            </li>

            <li class="nav-item">
                <button *ngIf="legajosFiltradosMultifiltro.length > 0" (click)="descargarExcel()"
                    class="btn btn-primary me-2 my-2">
                    <i class="fa fa-file-excel-o" aria-hidden="true"></i> Descargar Excel
                </button>
            </li>
        </ul>
    </div>
</nav>


<div class="row card-body mt-3">
    <div class="col-md-12">
        <div class="spinner-container" *ngIf="cargandoLista">
            <ngx-spinner name="spinnerGrafico" [ngStyle]="{'height': '400px', 'z-index':'0'}" bdOpacity=0.3bd
                Color="rgba(193,193,193,0)" size="medium" color="#185db5" type="ball-grid-beat" [fullScreen]="false">
                <p style="color: white">C a r g a n d o . . . </p>
            </ngx-spinner>
        </div>
    </div>


    <div class="abs-center" *ngIf="!cargandoLista && primerLlamado && legajosFiltrados.length==0">
        <ngb-alert type="warning"> No se encontraron facturas registradas para el rango de fechas seleccionado.
        </ngb-alert>
    </div>

    <div class="card-body tabla-legajos" *ngIf="!cargandoLista && legajosFiltrados.length > 0">
        <table class="table table-striped table-hover">
            <thead class="text-center">
                <tr>
                    <th>
                        <app-item-multifiltro [lista]="legajosFiltrados" [elementos]="aerovaleMultiFiltro"
                            (elementosChange)="recargarItems('aerovaleMultiFiltro', $event)"
                            [nombreAtributo]="'aerovale'" [encabezadoColumna]="'Aerovale'">
                        </app-item-multifiltro>

                    </th>
                    <th>
                        <app-item-multifiltro [lista]="legajosFiltrados" [elementos]="legajoMultiFiltro"
                            (elementosChange)="recargarItems('legajoMultiFiltro', $event)" [nombreAtributo]="'legajo'"
                            [encabezadoColumna]="'Legajo'">
                        </app-item-multifiltro>

                    </th>
                    <th>
                        <app-item-multifiltro [decoratorFn]="obtenerEstadoAerovale" [lista]="legajosFiltrados"
                            [elementos]="estadoAerovaleMultiFiltro"
                            (elementosChange)="recargarItems('estadoAerovaleMultiFiltro', $event)"
                            [nombreAtributo]="'estadoAerovale'" [encabezadoColumna]="'Estado Aerovale'">
                        </app-item-multifiltro>
                    </th>
                    <th>
                        <app-item-multifiltro [decoratorFn]="obtenerTipoModificacion" [lista]="legajosFiltrados"
                            [elementos]="tipoModificacionMultiFiltro"
                            (elementosChange)="recargarItems('tipoModificacionMultiFiltro', $event)"
                            [nombreAtributo]="'tipoSolicitudRefacturacion'" [encabezadoColumna]="'Tipo Solicitud'">
                        </app-item-multifiltro>
                    </th>
                    <th>
                        <app-item-multifiltro [decoratorFn]="obtenerMotivo" [lista]="legajosFiltrados"
                            [elementos]="motivoMultiFiltro"
                            (elementosChange)="recargarItems('motivoMultiFiltro', $event)"
                            [nombreAtributo]="'motivoRefacturacion'" [encabezadoColumna]="'Motivo'">
                        </app-item-multifiltro>
                    </th>
                    <th>
                        <app-item-multifiltro [lista]="legajosFiltrados" [elementos]="productoMultiFiltro"
                            (elementosChange)="recargarItems('productoMultiFiltro', $event)"
                            [nombreAtributo]="'producto'" [encabezadoColumna]="'Producto'">
                        </app-item-multifiltro>
                    </th>
                    <th>
                        <app-item-multifiltro [lista]="legajosFiltrados" [elementos]="aerovaleReemplazoMultiFiltro"
                            (elementosChange)="recargarItems('aerovaleReemplazoMultiFiltro', $event)"
                            [nombreAtributo]="'aerovaleReemplazo'" [encabezadoColumna]="'Aerovale Reemplazo'">
                        </app-item-multifiltro>

                    </th>
                    <th>Adjunto</th>
                    <th>
                        <app-item-multifiltro [lista]="legajosFiltrados" [elementos]="aeroplantaMultiFiltro"
                            (elementosChange)="recargarItems('aeroplantaMultiFiltro', $event)"
                            [nombreAtributo]="'aeroplanta'" [encabezadoColumna]="'Aeroplanta'">
                        </app-item-multifiltro>
                    </th>
                    <th>
                        <app-item-multifiltro [lista]="legajosFiltrados" [elementos]="clienteMultiFiltro"
                            (elementosChange)="recargarItems('clienteMultiFiltro', $event)" [nombreAtributo]="'cliente'"
                            [encabezadoColumna]="'Cliente'">
                        </app-item-multifiltro>
                    </th>
                    <th>
                        <app-item-multifiltro [lista]="legajosFiltrados" [elementos]="cuentaMultiFiltro"
                            (elementosChange)="recargarItems('cuentaMultiFiltro', $event)" [nombreAtributo]="'cuenta'"
                            [encabezadoColumna]="'Cuenta'">
                        </app-item-multifiltro>
                    </th>
                    <th>Fecha Reemplazo</th>
                    <th>Fecha Fin Despacho</th>
                    <th>
                        <app-item-multifiltro [lista]="legajosFiltrados" [elementos]="facturaMultiFiltro"
                            (elementosChange)="recargarItems('facturaMultiFiltro', $event)" [nombreAtributo]="'factura'"
                            [encabezadoColumna]="'Factura'">
                        </app-item-multifiltro>

                    </th>
                    <th>
                        <app-item-multifiltro [decoratorFn]="obtenerEstadoFactura" [lista]="legajosFiltrados"
                            [elementos]="estadoFacturaMultiFiltro"
                            (elementosChange)="recargarItems('estadoFacturaMultiFiltro', $event)"
                            [nombreAtributo]="'estadoFactura'" [encabezadoColumna]="'Estado Factura'">
                        </app-item-multifiltro>
                    </th>
                    <th>
                        <app-item-multifiltro [lista]="legajosFiltrados" [elementos]="facturaNuevaMultiFiltro"
                            (elementosChange)="recargarItems('facturaNuevaMultiFiltro', $event)"
                            [nombreAtributo]="'facturaNueva'" [encabezadoColumna]="'Factura Nueva'">
                        </app-item-multifiltro>
                    </th>
                    <th>
                        <app-item-multifiltro [decoratorFn]="obtenerEstadoFactura" [lista]="legajosFiltrados"
                            [elementos]="estadoFacturaNuevaMultiFiltro"
                            (elementosChange)="recargarItems('estadoFacturaNuevaMultiFiltro', $event)"
                            [nombreAtributo]="'estadoFacturaNueva'" [encabezadoColumna]="'Estado Factura Nueva'">
                        </app-item-multifiltro>
                    </th>
                    <th>Fecha Registro</th>
                    <th>Comparativa facturas</th>
                    <th>Comparativa aerovales</th>
                </tr>
            </thead>
            <tbody class="text-center" style="vertical-align: middle;">
                <tr *ngFor="let s of legajosFiltradosMultifiltro; let i = index;">
                    <td>{{ s.aerovale }}</td>
                    <td>{{ s.legajo }} <br> <small>{{ s.legajoFecha | date: "dd/MM/yyyy HH:mm" }}</small></td>
                    <td>{{ obtenerEstadoAerovale(s.estadoAerovale) }}</td>
                    <td>{{ obtenerTipoModificacion(s.tipoSolicitudRefacturacion) }}</td>
                    <td>{{ obtenerMotivo(s.motivoRefacturacion) }}</td>
                    <td>{{ s.producto }}</td>
                    <td>{{ (s.aerovaleReemplazo && s.tipoSolicitudRefacturacion !== TipoSolicitudRefacturacion.Anulacion) ?
                        s.aerovaleReemplazo : '--' }}</td>
                    <td>
                        <button *ngIf="s.adjunto!=null" class="btn" placement="bottom" ngbTooltip="Descargar Adjunto"
                            container="body">
                            <a class="fa fa-download" [href]="s.adjunto"></a>
                        </button>
                        <div *ngIf="s.adjunto===null">--</div>
                    </td>
                    <td>{{ s.aeroplanta }}</td>
                    <td>{{ s.cliente }}</td>
                    <td>{{ s.nroCuenta }}</td>
                    <td>{{ (s.fechaReemplazo && s.tipoSolicitudRefacturacion !== TipoSolicitudRefacturacion.Anulacion && !(s.tipoSolicitudRefacturacion == TipoSolicitudRefacturacion.Manual && s.motivoRefacturacion == Motivo.Despacho)) ?
                        (s.fechaReemplazo | date: "dd/MM/yyyy HH:mm") : '--' }}</td>
                    <td>{{ s.fechaFinDespacho ? (s.fechaFinDespacho | date: "dd/MM/yyyy HH:mm") : '--' }}</td>
                    <td>{{ s.factura || '--'}}</td>
                    <td>{{ obtenerEstadoFactura(s.estadoFactura) }}</td>
                    <td>{{ s.facturaNueva || '--' }}</td>
                    <td>{{ obtenerEstadoFactura(s.estadoFacturaNueva) }}</td>
                    <td>{{ s.fecha ? (s.fecha | date: "dd/MM/yyyy HH:mm") : '--' }}</td>
                    <td>
                        @if (s.facturaNueva) {
                        <button class="btn" (click)="verComparativasFacturas(content, s, i)"
                            ngbTooltip="Ver comparativas">
                            <i *ngIf="!previsualizando || previsualizando && itemSeleccionado!=i" class="fa fa-eye"
                                aria-hidden="true"></i>
                            <div *ngIf="previsualizando && itemSeleccionado==i"
                                class="spinner-border text-primary spinner-border-sm" role="status"></div>
                        </button>
                        } @else {
                        <div>--</div>
                        }
                    </td>
                    <td>
                        @if (s.aerovaleReemplazo) {
                        <button class="btn" (click)="verComparativasAerovales(contentAerovale, s, i)"
                            ngbTooltip="Ver comparativas">
                            <i *ngIf="!previsualizandoAerovale || previsualizandoAerovale && itemSeleccionado!=i"
                                class="fa fa-eye" aria-hidden="true"></i>
                            <div *ngIf="previsualizandoAerovale && itemSeleccionado==i"
                                class="spinner-border text-primary spinner-border-sm" role="status"></div>
                        </button>
                        } @else {
                        <div>--</div>
                        }
                    </td>
                </tr>
            </tbody>

        </table>
    </div>
    <ng-template #content let-modal style="overflow-y:scroll">
        <div class="row">
            <div class="col-md-6" style="text-align:center">
                <b>Factura original</b>
            </div>
            <div class="col-md-6" style="text-align:center">
                <b>Nuevo Comprobante</b>
            </div>
        </div>
        <div class="row" id="print">
            <app-visor-comprobante *ngIf="this.facturaObtenida!=null" class="col-md-6"
                [facturaObtenida]='this.facturaObtenida'></app-visor-comprobante>
            <app-previsualizacion-comprobante *ngIf="this.facturaCalculada!=null" class="col-md-6"
                [facturaCalculada]='this.facturaCalculada'></app-previsualizacion-comprobante>
        </div>
        <div class="col-4">
            <button styleSheetFile="assets/css/printRefacturacion.css, assets/css/bootstrap.min.css"
                printSectionId="print" useExistingCss="true" class="btn btn-sm btn-outline-secondary ms-1 mb-1"
                printTitle="{{tituloFactura}}" ngxPrint>
                <i class="fa fa-print" aria-hidden="true"></i> Imprimir </button>
        </div>
    </ng-template>

    <ng-template #contentAerovale let-modal style="overflow-y:scroll">
        <div class="row">
            <div class="col-md-6" style="text-align:center">
                <b>Aerovale original</b>
            </div>
            <div class="col-md-6" style="text-align:center">
                <b>Nuevo Aerovale</b>
            </div>
        </div>
        <div class="row" id="print">
            <app-aerovale-detalle *ngIf="this.aerovaleDetalle!=null" class="col-md-6"
                [aerovaleDetalle]='this.aerovaleDetalle'></app-aerovale-detalle>
            <app-aerovale-detalle *ngIf="this.aerovaleDetalleNuevo!=null" class="col-md-6"
                [aerovaleDetalle]='this.aerovaleDetalleNuevo' [previsualizar]="true"></app-aerovale-detalle>
        </div>
        <div class="col-4">
            <button styleSheetFile="assets/css/printRefacturacionAerovale.css, assets/css/bootstrap.min.css"
                printSectionId="print" useExistingCss="true" class="btn btn-sm btn-outline-secondary ms-1 mb-1"
                printTitle="{{tituloAerovale}}" ngxPrint>
                <i class="fa fa-print" aria-hidden="true"></i> Imprimir </button>
        </div>
    </ng-template>
</div>